import { __assign } from "tslib";
import React from 'react';
export default function Right(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        React.createElement("polygon", { fill: "currentColor", points: "5.657 3.657 5.656 10.656 12.657 10.657 12.657 12.657 3.657 12.657 3.657 3.657", transform: "rotate(-135 8.157 8.157)" })));
}
//# sourceMappingURL=Right.js.map